import { Box } from '@mui/material';
import ActiveDeactivateButton from './ActiveDeactiveButton';

const ComptrollerActiveButton = ({ activationStatus, type, deactivateHandler }) => {
	return (
		<Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: '8px' }}>
			{type === 'View' && (
				<Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
					<>
						{activationStatus && (
							<ActiveDeactivateButton
								activationStatus={activationStatus}
								handleOnClick={(e) => {
									e.stopPropagation();

									deactivateHandler();
								}}
							/>
						)}
					</>
				</Box>
			)}
		</Box>
	);
};

export default ComptrollerActiveButton;
